<template>
  <div class="tip-wrapper">
    <div
    v-for="(item, index) in title"
    :key="index">
      <p>
        {{item.title}}
        <span class="tip" 
          :class="item.className">
          {{item.value}}
        </span>
      </p>
      <p v-if="!isLikeMin1 && titleData[index+4]">
        {{titleData[index+4].title}}
        <span class="tip" 
          :class="titleData[index+4].className">
          {{titleData[index+4].value}}
        </span>
      </p>
      <p v-else style="height:20px"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['titleData', 'isLikeMin1'],
  computed: {
    title() {
      return this.isLikeMin1 ? this.titleData : this.titleData.slice(0, 4)
    }
  }
}
</script>

<style scoped>
  .tip-wrapper{
    display: flex;
    justify-content: space-around;
    align-items: center
  }
  .rise-color {
    color: #E63535
  }
  .fall-color {
    color: #1BAA3C
  }
</style>